import { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";
import StyledCard from 'components/StyledCard';
import styled from "styled-components";
import PageLayout from "components/PageLayout";
import BackButton from "components/BackButton";
import TextField from '@material-ui/core/TextField';
import DayJS from 'react-dayjs';
import useAuth from "../../hooks/useAuth";
import useDb from "../../hooks/useDb";
import useFormDataApi from "../../hooks/useFormDataAPI"
import { useForm } from 'react-hook-form';
import useAppointment from "../../hooks/useAppointment";
import useAPI from "hooks/useAPI";
import useStyles from './styles';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { useAlert } from "../../providers/AlertService";
import useGlobalLoading from "hooks/useGlobalLoading"
import Compressor from "compressorjs";

const DeleteButton = styled.button`
  position: absolute;
  color: red;
  font-weight: bold;
  font-size: 1.5rem;
  top: 10px;
  right: 10px;
`;

const Picture = styled.img`
  width: 100%;
  height: 100%;
`;


const DuctLeakageHub = () => {
  const { register, handleSubmit, control } = useForm();
  const { setIsLoading } = useGlobalLoading();
  const formDataApi = useFormDataApi();
  const imgRef = useRef();
  const db = useDb();
  const params = useParams();
  const history = useHistory();
  const { appointmentId } = params;
  const { appointment, setAppointment } = useAppointment(appointmentId);
  const [forms, setForms] = useState([]);
  const styles = useStyles();
  const instance = useAPI();
  const alert = useAlert();

  const formsMetadata = [
    { name: 'ductLeakagePage1', label: 'page 1', path: `/form/duct-leakage/1/1/${appointmentId}`, version: process.env.REACT_APP_NGAT_VERSION },
    { name: 'ductLeakagePage2', label: 'page 2', path: `/form/duct-leakage/1/2/${appointmentId}`, version: process.env.REACT_APP_NGAT_VERSION },
    { name: 'ductLeakagePage3', label: 'page 3', path: `/form/duct-leakage/1/3/${appointmentId}`, version: process.env.REACT_APP_NGAT_VERSION },
  ]

  const submitEmptyAppointment = reasonForReschedule => {
    setIsLoading(true);

    const data = new FormData();
    data.append('reasonForReschedule', reasonForReschedule.rescheduleReason)
    console.log(data);

    formDataApi
      .post(`/appointments/${appointment._id}/finalize`, data)
      .then(res => {
        toast.success('Successfully submitted images!');
        setAppointment({
          ...appointment,
          completed: true
        });

        history.push('/');
      })
      .catch(err => {
        toast.error(err.message)
      })
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    Promise.all(formsMetadata.map(async metadata => {
      const result = await db.forms.get({ appointmentId, type: metadata.name, version: metadata.version });

      return {
        ...metadata,
        reviewed: result?.reviewed
      }
    }))
      .then(res => {
        console.log(res)
        setForms(res)
      });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const removeForm = (form) => {
    const result = window.confirm('Are you sure you want to delete the data for this form?');
    if (result === true)
      db.forms
        .where({
          appointmentId,
          type: form.name,
          version: form.version
        })
        .delete()
        .then(setForms(forms => forms.map(f => ({ ...f, reviewed: f.name === form.name ? undefined : f.reviewed }))))
  }

  if (!appointment) return null;

  return (
    <PageLayout title="Duct Leakage Hub">
      <Container maxWidth="sm">
        <>
          <Box display="flex" alignItems="center" justifyContent="space-between">
          </Box>
          <h2>Pages:</h2>
          <Box>
            {forms.map(form => {
              console.log(form.name, form.reviewed)
              return <div key={form.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Link to={`${form.path}`} className={styles.formButton}>{form.label}</Link>
                <Brightness1Icon
                  style={{
                    color: form.reviewed === undefined
                      ? 'white'
                      : form.reviewed === 0
                        ? 'yellow'
                        : 'green'
                  }}
                />
                {form.reviewed !== undefined &&
                  <DeleteForeverIcon
                    id={`${form.name}-trash`}
                    onClick={() => removeForm(form)}
                  />}
              </div>
            })}
          </Box>
          <p></p>
        </>
        <form onSubmit={handleSubmit(submitEmptyAppointment)}>
        </form>
      </Container>
    </PageLayout>
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();

  return (
    <PrivateContent title="Appointment">
      <DuctLeakageHub />
    </PrivateContent>
  );
};

export default DuctLeakageHub;
